import React from 'react';
import styled from 'styled-components';

const DefaultCard = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #fff;
  padding: 1rem;
  border: 1px solid #e5e9f0;
  box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.1);

  .Card__title {
    margin-bottom: .25rem;
    font-size: .875rem;
    font-weight: 700;
    letter-spacing: -1px;
    text-transform: uppercase;
  }

  .Card__data {
    color: #a3be8c;
    font-size: 1.25rem;
    font-weight: 900;

    + .Card__subtitle {
      margin-top: .5rem;
    }
  }

  .Card__subtitle {
    color: #4c566a;
    font-weight: 700;
    font-size: .75rem;
    text-transform: uppercase;
  }
`;

const Card = ({children}) => {
  return (
    <DefaultCard>
      {children}
    </DefaultCard>
  );
};

export default Card;
